export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fece013e8f8f14d04e18a8bcc57a11b420c5e6ed7&name=fetchTypeahead!'